<!--
 * @LastEditors: zhanglinju
-->
<template>
  <div
    :class="routerName==='mobileModules'?'swipeView':'swipeView2'"
  >
    <van-swipe
      :class="routerName==='mobileModules'?'my-swipe':'my-swipe2'"
      :autoplay="3000"
      indicator-color="white"
    >
      <van-swipe-item
        v-for="(item, index) in list"
        :key="index"
        style="position:relative;"
      >
        <div
          :class="routerName==='mobileModules'?'ImgDiv':'ImgDiv2'"
        >
          <img
            :src="item.image"
            alt=""
            @click="openDetails(item)"
          >
        </div>
      </van-swipe-item>
    </van-swipe>
    <div
      v-if="vdo"
      class="theVideoStratum"
      @click="vdo = false"
    >
      <div
        style="width: 100%; height: 100%; background-color: rgba(0, 0, 0)"
        class="closeTheVideo"
      />
      <div
        :class="routerName==='mobileModules'?'theVideoStratumBox':'theVideoStratumBox2'"
      >
        <video
          ref="myVideo"
          x5-playsinline=""
          webkit-playsinline="true"
          playsinline="true"
          :src="videoUrl"
          autoplay="autoplay"
          controls="controls"
          class="vdo"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
    props: {
        list: {
            default: null,
            type: Array,
        },
        siteId: {
            default: null,
            type: String,
        },
    },
    data () {
        return {
            vdo: false,
            videoUrl: null,
            routerName: null,
        };
    },
    created () {
        this.routerName = this.$route.name;
    },
    mounted () {

    },
    methods: {
        init () {
            this.getrotationInfoList();
        },

        openDetails (e) {
            console.log(e);
            // eslint-disable-next-line eqeqeq
            if (e.type == 2) {
                this.videoUrl = e.video;
                this.vdo = true;
            // eslint-disable-next-line eqeqeq
            } else if (e.type == 1) {
                console.log(e.link);
                sessionStorage.setItem('iframeUrl', e.link);
                if (this.routerName === 'mobileModules') {
                    this.$router.push({ name: 'mobileBoxContent', query: { url: e.link } });
                } else {
                    this.$router.push({ name: 'mobileContent', query: { url: e.link } });
                }
            // eslint-disable-next-line eqeqeq
            } else if (e.type == 0) {
                if (this.routerName === 'mobileModules') {
                    this.$router.push({ name: 'mobileBoxContent', query: { contentId: e.contentId } });
                } else {
                    this.$router.push({ name: 'mobileContent', query: { contentId: e.contentId } });
                }
            }
        },
    },
};
</script>
<style lang='scss' scoped>
.swipeView {
  width: 100%;
  z-index: 10000;
  background: #ededed;
}
.swipeView2 {
  width: 100%;
  z-index: 10000;
  background: #ededed;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  img {
    max-width:  100%;
    max-height: 100%;
  }
}
.my-swipe2 .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  img {
    max-width:  100%;
    max-height: 100%;
  }
}
.theVideoStratum{
  position: relative;
}
.theVideoStratumBox {
  position: absolute;
  bottom: -710px;
  left: 50.4%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  background-color:rgb(0, 0, 0);
  z-index: 9999;
  width: 346px;
  height: 580px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.theVideoStratumBox2{
  position: absolute;
  top: -189px;
  background-color:rgba(0, 0, 0,0.5);
  z-index: 9999;
  width: 100vw;
  height: 104.5vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vdo {
  width: 100%;
}
.ImgDiv{
  width: 100%;
  height: 227px;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    max-width: 100%;
    max-height: 100%;
  }
}
.ImgDiv2{
    width: 100vw;
    height: calc(100vw / 2.2);
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      max-width: 100%;
      max-height: 100%;
    }
}
</style>
